import { Component, EventEmitter, Input, Output } from '@angular/core';
import { fadeIn, fadeOut, RESPONSE_TYPES } from '@portals/utils';
import { ResponseService } from '@portals/core';
import { Channel, Notification } from '@portals/api';
import { TranslateService } from '@ngx-translate/core';
@Component({
	selector: 'web-toggler',
	templateUrl: './toggler.component.html',
	styleUrls: ['./toggler.component.scss'],
	animations: [fadeIn, fadeOut],
})
export class TogglerComponent {
	@Input() isRecording: boolean = false;
	@Input() typingMode: boolean = false;
	@Input() startAnimation: boolean = false;
	@Input() finishedResponding: boolean = false;
	@Input() maxVideoTime: number | undefined = 0;
	@Input() activeScreen!: RESPONSE_TYPES;
	@Output() setActiveScreen: EventEmitter<RESPONSE_TYPES> = new EventEmitter<RESPONSE_TYPES>();
	@Output() timerStop: EventEmitter<void> = new EventEmitter<void>();
	notification = this.responseService.currentPage?.parameters?.notification as Notification;
	notificationType = this.responseService.currentPage?.parameters?.notificationType as RESPONSE_TYPES;
	channel = this.responseService.currentPage?.parameters?.channel as Channel;
	protected readonly RESPONSE_TYPES = RESPONSE_TYPES;
	currentLanguage = 'en';
	customLocalizationSet = false;
	constructor(protected responseService: ResponseService, private translate: TranslateService) {
		const systemDefaultLanguage = navigator.language.split('-')[0];
		const supportedLanguages = ['en', 'es'];
		const defaultLanguage = supportedLanguages.includes(systemDefaultLanguage) ? systemDefaultLanguage : 'en';
		translate.setDefaultLang(defaultLanguage);
		if (this.notification.localization) {
			this.currentLanguage = this.notification.localization;
			this.customLocalizationSet = true;
			translate.setDefaultLang(this.notification.localization);
		}
		if (this.channel.localization && !this.customLocalizationSet) {
			this.currentLanguage = this.channel.localization;
			this.customLocalizationSet = true;
			translate.setDefaultLang(this.channel.localization);
		}
	}
}
